<template>
  <bita-modal :id="modalId" :title="title" :modal-lg="true">
    <div slot="body">
      <div class="row">
        <div class="col-12">
          <div class="alert alert-primary" role="alert">اطلاعات شخصی</div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>نام</label>
            <input class="form-control" :value="this.propsData.name" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>نام خانوادگی</label>
            <input class="form-control" :value="this.propsData.family" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>کدملی</label>
            <input class="form-control" :value="this.propsData.national_code" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>شماره تماس</label>
            <input class="form-control" :value="this.propsData.phone" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>کدپستی</label>
            <input class="form-control" :value="this.propsData.postal_code" disabled />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>آدرس</label>
            <textarea class="form-control" :value="this.propsData.address" disabled />
          </div>
        </div>
        <div class="col-12">
          <div class="alert alert-primary" role="alert">اطلاعات باربری</div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>نام رئیس</label>
            <input class="form-control" :value="this.propsData.boss_name" disabled />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label>کدباربری</label>
            <input class="form-control" :value="this.propsData.carrier_code" disabled />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    title: {},
    propsData: {
      type: Object,
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
    };
  },
};
</script>
